<template>
  <div
    class="learn-container learn"
    oncontextmenu="return false"
    onselectstart="return false"
  >
    <div class="heads flex-row-start">
      <a href="javascript:;" class="back" @click="goBack"></a>
      <div class="heads-title">当前知识点：</div>
      <div class="heads-title-value">{{ courseInfo.knowledgeString }}</div>
    </div>
    <div class="video-info-box">
      <div class="video-info flex-between">
        <div class="left">
          <img
            src="https://wk.canpoint.net/Template/style1/style_img/xxxxxxxx.gif"
            class="vidoe-init-img"
            v-if="videoLoading"
            alt=""
          />
          <video-player
            class="video-player-box "
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @timeupdate="onPlayerTimeupdate($event)"
            customEventName="customstatechangedeventname"
            v-else
          >
          </video-player>
        </div>
        <div class="right">
          <div class="right-info relative">
            <span>老师：{{ courseInfo.teacher_name }}</span>
            <img
              src="../../assets/images/s-vip.png"
              class="teacher-vip"
              v-if="courseInfo.teacher_is_certificate == '有'"
              alt=""
              srcset=""
            />
          </div>
          <div class="right-info">昵称：{{ courseInfo.teacher_nickname }}</div>
          <div class="right-info">时长：{{ courseInfo.ke_time }}</div>
          <div class="intro">
            {{ courseInfo.ke_introduction || "暂无" }}
          </div>
          <div style="font-size: 12px;padding-top:5px">注：全品学堂的所有作品均为北京全品文教科技股份有限公司合法拥有著作权及邻接权的作品，未经授权不得转载、摘编或利用其它方式使用作品。</div>
        </div>
      </div>
    </div>
    <div class="but-box flex-row ">
      <div class="button-back button-init" @click="goBack">返回</div>
      <div class="button-exercise button-init" @click="onEmigrated">
        闯关练习
      </div>
    </div>
  </div>
</template>
<script>
import "video.js/dist/video-js.css";
import "@/assets/css/video.css";
import { videoPlayer } from "vue-video-player";
export default {
  components: {
    videoPlayer,
  },
  data() {
    return {
      courseInfo: {},
      playerOptions: {},
      videoLoading: true,
    };
  },
  created() {
    this.videoIngTime = 0;
    this.isSetCharging = false;
    this.cid = parseInt(this.$route.params.cid);
    this.getCourseInfo();
  },
  methods: {
    getCourseInfo() {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/tongbu/getByIdCourseInfo", {
        id: this.cid,
        model_type: 2,
      })
        .then((result) => {
          this.courseInfo = result.data;
          if (result.error_code > 0) {
            return false;
          }
          this.getVideo(this.courseInfo.video_id);
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    getVideo(videoId) {
      this.getRequest("/wenjiaoopne/kc/course/getVideoPlayUrl", {
        video_id: videoId,
        type: 3,
      })
        .then((result) => {
          if (result.error_code != 0) {
            this.$message.error(result.message)
            return false;
          }
          this.playerOptions = {
            height: 445,
            muted: false,
            autoplay: false,
            language: "zh-CN",
            preload: "auto",
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            notSupportedMessage: "此视频暂无法播放，请稍后再试",
            sources: [
              {
                type: "video/mp4",
                src: result.data.video_url,
              },
            ],
            poster: `https://api.canpoint.net/wk/AliyunVideo/getimgyurl?vid=${videoId}`,
          };
          this.videoLoading = false;
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    // 播放
    onPlayerPlay(player) {
      console.log("播放!", player);
      // this.player.play();
      this.setVideoCharging();
      this.setVideoInterval();
    },
    // 暂停
    onPlayerPause(player) {
      console.log("暂停!", player);
      clearTimeout(this.videoTime);
      this.setVideoTime();
    },
    // 记录播放时间
    onPlayerTimeupdate(e) {
      this.videoIngTime = e.cache_.currentTime;
    },
    setVideoCharging(){
      if(this.isSetCharging){
        return
      }
      this.isSetCharging = true;
      this.getRequest("/wenjiaoopne/kc/course/setVideoCharging", {})
        .then((result) => {
          console.log(result)
        })
        .catch(() => {});
    },
    setVideoInterval() {
      this.videoTime = setInterval(() => {
        this.setVideoTime();
      }, 3000);
    },
    setVideoTime() {
      this.getRequest("/wenjiaoopne/kc/course/setVideoTime", {
        video_id: this.courseInfo.video_id,
        play_time: this.videoIngTime,
      })
        .then(() => {})
        .catch(() => {
          clearTimeout(this.videoTime);
        });
    },
    goBack() {
      this.$router.push("/student/zihuixue?back=1");
    },
    onEmigrated() {
      this.$router.push("/student/zihuixue/learned/" + this.cid);
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
  destroyed() {
    clearTimeout(this.videoTime);
  },
};
</script>
<style scoped>
.learn-container {
  width: 100%;
}
.learn-container .heads {
  width: 100%;
  height: 50px;
  background-color: #fff;
}
.learn-container .back {
  display: inline-block;
  width: 91px;
  height: 50px;
  background-image: url("../../assets/images/4.gif");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.learn-container .heads-title,
.heads-title-value {
  display: inline-block;
}
.learn-container .heads-title {
  margin-left: 20px;
  color: #7a8aa3;
}
.learn-container .heads-title-value {
  color: #40b8ee;
  font-size: 24px;
}
.learn-container .video-info-box {
  width: 100%;
  background-color: #ffffff;
}
.video-info {
  margin: 0 35px;
  padding-top: 15px;
}
.learn-container .left {
  width: 790px;
  height: 445px;
  background-color: antiquewhite;
}
.learn-container .right {
  width: 235px;
  height: 405px;
  padding: 20px 35px;
  background-color: #f6f9ff;
  color: #7b899f;
}
.learn-container .right .right-info {
  margin: 20px 0;
}
.learn-container .right .intro {
  width: 90%;
  height: 165px;
  padding: 10px;
  border-radius: 10px;
  font-size: 14px;
  background-color: #fff;
}
.teacher-vip {
  position: absolute;
  top: 0px;
  right: 20px;
  width: 82px;
  height: 22px;
}
.vidoe-init-img {
  width: 100%;
  height: 100%;
}
.but-box {
  width: 100%;
  height: 90px;
  background-color: #fff;
}
.button-back {
  background-color: #f9bb00;
}
.button-exercise {
  background-color: #40b8ee;
}
.button-init {
  width: 552px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  margin: 0 10px;
  font-size: 20px;
  cursor: pointer;
}
</style>
